export default __webpack_public_path__ + "static/media/Express_-_adamr.space___Codecademy.41d1cfe9.pdf";